import React from "react";
import { AuthenticationManager, ResourceID } from "../../../common/AuthenticationManager";
import { GenericMessages } from "../../../common/Constants";
import { StringHelper } from "../../../common/Helpers";
import RestClient from "../../../common/RestClient";
import { BreadCrumb } from "../../common/BreadCrumb";
import { ConfirmDialog } from "../../common/ConfirmDialog";
import { CancelPreviewButton } from "../common/CancelPreviewButton";
import { CardMode } from "../common/CardMode";
import { PromotionDetailCard } from "./cards/PromotionDetailCard";
import { PromotionPreview } from "./preview/PromotionPreview";
import {
  NavigationItem,
  NavigationSettings,
} from "../../common/NavigationSettings";
import { toast } from "react-toastify";
import ButtonActionDetailGroup from "../../common/ButtonActionDetailGroup";

const EditPageName = "Edit Scheduled Promotion";
const ViewPageName = "View Scheduled Promotion";

export class ScheduledPromotionDetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      cardMode: CardMode.ScheduleView,
      generalInfo: null,
      generalInfoValidations: [],
      scheduledPromotion: null,
      scheduledPromotionId: "",
      showCancelDialog: false,
      showConfirmDialog: false,
      showPreview: false,
      showDeleteModal: false,
    };
  }

  componentDidMount() {
    const { id } = this.props.match.params;
    const scheduledPromotionId = StringHelper.toNumber(id, 0);
    if (isNaN(id) || scheduledPromotionId <= 0) {
      this.redirectToListingPage();
      return;
    }
    this.setState({ scheduledPromotionId }, this.refreshData);
  }

  isValidated() {
    const { generalInfoValidations } = this.state;
    return generalInfoValidations.every((val) => val.isValid);
  }

  loadScheduledPromotion(id) {
    RestClient.sendGetRequest(
      `/api/v1/scheduled_promotions/${id}`,
      (response) => {
        this.setState({ scheduledPromotion: response });
      },
      (errorResponse) => {
        toast.error(errorResponse.message);
      }
    );
  }

  onEditPromotionClick = () => {
    this.setState({ cardMode: CardMode.ScheduleUpdate });
  };

  onGeneralInfoModelChange = (model) => {
    const displayStartTime = StringHelper.toDateTimeString(
      model.displayStartTimeStr
    );
    const displayEndTime = StringHelper.toDateTimeString(
      model.displayEndTimeStr
    );
    const planToPublish = StringHelper.toDateTimeString(model.planToPublishStr);
    const category = StringHelper.toNumber(model.category, 0);
    const weightDisplay = StringHelper.toNumber(model.weightDisplay, 0);
    const newModel = Object.assign(model, {
      category,
      displayStartTime,
      displayEndTime,
      planToPublish,
      weightDisplay,
    });
    this.setState({ generalInfo: newModel });
  };

  onGeneralInfoValidationsChange = (validations) => {
    this.setState({ generalInfoValidations: validations });
  };

  onHideCancelDialog = () => {
    this.setState({ showCancelDialog: false });
  };

  onHideConfirmDialog = () => {
    this.setState({ showConfirmDialog: false });
  };

  onHidePreview = () => {
    this.setState({ showPreview: false });
  };

  onProceedCancelDialog = () => {
    this.setState({
      cardMode: CardMode.ScheduleView,
      scheduledPromotion: Object.assign({}, this.state.scheduledPromotion),
      showCancelDialog: false,
    });
  };

  onProceedConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true, showConfirmDialog: false });
      return;
    }
    const { generalInfo, scheduledPromotionId } = this.state;
    const request = Object.assign(
      {},
      generalInfo
    );
    RestClient.sendPutRequest(
      `/api/v1/scheduled_promotions/${scheduledPromotionId}`,
      request,
      (response) => {
        toast.success(GenericMessages.SaveChangesSuccessfulMessage);
        this.setState({
          cardMode: CardMode.ScheduleView,
          isSubmit: false,
          scheduledPromotion: response,
          showConfirmDialog: false,
        });
      },
      (errorResponse) => {
        toast.success(errorResponse.message);
        this.setState({
          showConfirmDialog: false,
        });
      }
    );
  };

  onShowCancelDialog = () => {
    this.setState({ showCancelDialog: true });
  };

  onShowConfirmDialog = () => {
    if (!this.isValidated()) {
      this.setState({ isSubmit: true });
      return;
    }
    this.setState({ showConfirmDialog: true });
  };

  onShowPreview = () => {
    this.setState({ showPreview: true });
  };

  refreshData() {
    const { scheduledPromotionId } = this.state;
    this.loadScheduledPromotion(scheduledPromotionId);
  }

  redirectToListingPage(additionalParameter) {
    this.props.history.push(
      `/promotions/schedules/${additionalParameter ?? ""}`
    );
  }

  getNavigationSettings = () => {
    const { cardMode } = this.state;
    return new NavigationSettings({
      rootModule: new NavigationItem({
        identifier: "website_managements",
        name: "Website Management",
      }),
      parentModule: new NavigationItem({
        identifier: "promotions",
        name: "Promotions",
      }),
      activeModule: new NavigationItem({
        identifier: "promotion-creation",
        name: CardMode.isViewMode(cardMode) ? ViewPageName : EditPageName,
      }),
    });
  };

  onProceedDelete = () => {
    const { scheduledPromotionId } = this.state;
    RestClient.sendDeleteRequest(
      `/api/v1/scheduled_promotions/${scheduledPromotionId}`,
      () => {
        toast.success("The scheduled promotion has been deleted successful.");
        this.redirectToListingPage();
      }, (errorResponse) => {
        toast.error(errorResponse.message);
      }
    );
    this.setState({ showDeleteModal: false });
  }

  onDelete = () => {
    this.setState({ showDeleteModal: true });
  };

  onCancel = () => {
    this.setState({ showDeleteModal: false });
  };

  render() {
    const {
      cardMode,
      isSubmit,
      generalInfo,
      scheduledPromotion,
      showCancelDialog,
      showConfirmDialog,
      showPreview,
      showDeleteModal,
    } = this.state;
    if (showPreview) {
      const previewModel = Object.assign(
        {},
        generalInfo
      );
      return (
        <React.Fragment>
          <PromotionPreview promotion={previewModel} />
          <CancelPreviewButton onClick={this.onHidePreview} />
        </React.Fragment>
      );
    }
    return (
      <div className="main-content">
        <BreadCrumb navigationSettings={this.getNavigationSettings()} />
        <div className="section__content section__content--p30">
          <div className="container-fluid">
            {CardMode.isViewMode(cardMode) && (
              <div className="row mb-3">
                <div className="col">
                  <div className="d-flex flex-row-reverse">
                    {
                      AuthenticationManager.isAuthorized(
                        ResourceID.PromotionScheduledEditButtonPage
                      ) && (
                        <>
                          <button
                            className="btn btn-primary ml-2 mb-2"
                            value="Edit"
                            disabled={scheduledPromotion ? undefined : "disabled"}
                            onClick={this.onEditPromotionClick}
                          >
                            <i className="fas fa-edit"></i> Edit
                          </button>
                          <button
                            className="btn btn-danger ml-2 mb-2"
                            value="Delete Schedule"
                            disabled={scheduledPromotion ? undefined : "disabled"}
                            onClick={this.onDelete}
                          > Delete Schedule
                          </button>
                        </>
                      )
                    }
                  </div>
                </div>
              </div>
            )}
            <div className="row">
              <div className="col-md-12">
                <PromotionDetailCard
                  cardMode={cardMode}
                  defaultValue={scheduledPromotion}
                  isSubmit={isSubmit}
                  model={generalInfo}
                  onModelChange={this.onGeneralInfoModelChange}
                  onValidationsChange={this.onGeneralInfoValidationsChange}
                />
              </div>
            </div>
            {CardMode.isEditMode(cardMode) && (
              <ButtonActionDetailGroup>
                <ButtonActionDetailGroup.Item
                  className="btn btn-outline-secondary"
                  onClick={this.onShowPreview}
                >
                  Preview
                </ButtonActionDetailGroup.Item>
                <ButtonActionDetailGroup.Item
                  className="btn btn-success"
                  onClick={this.onShowConfirmDialog}
                >
                  Save Changes
                </ButtonActionDetailGroup.Item>
                <ButtonActionDetailGroup.Item
                  className="btn btn-danger"
                  onClick={this.onShowCancelDialog}
                >
                  Cancel
                </ButtonActionDetailGroup.Item>
              </ButtonActionDetailGroup>
            )}
          </div>
        </div>
        <ConfirmDialog
          visible={showCancelDialog && scheduledPromotion}
          onCancel={this.onHideCancelDialog}
          onProceed={this.onProceedCancelDialog}
          message={GenericMessages.CancelChangesDialogMessage}
          title={GenericMessages.CancelChangesDialogTitle}
        />
        <ConfirmDialog
          visible={showConfirmDialog && scheduledPromotion}
          onCancel={this.onHideConfirmDialog}
          onProceed={this.onProceedConfirmDialog}
          message={GenericMessages.SaveChangesDialogMessage}
          title={GenericMessages.SaveChangesDialogTitle}
        />
        <ConfirmDialog
          visible={showDeleteModal}
          message={"Are you sure you want to delete this scheduled promotion?"}
          onProceed={this.onProceedDelete}
          onCancel={this.onCancel}
        />
      </div>
    );
  }
}
